import {
  Check,
  Sparkles,
  ArrowRight,
  ShieldCheck,
  DollarSign,
  Layers,
  CheckCircle2,
} from 'lucide-react'
const PricingAndRoi = ({ onSelectPlan }) => {
  const includedFeatures = [
    'Gesti\xF3n y cobertura completa para 10 clientes activos simult\xE1neos',
    'Acceso \xEDntegro al Dream Team de 10 Agentes Especializados de IA',
    'Oficina Virtual 24/7 con central de mando y vistas en tiempo real',
    'Aislamiento estricto de bases de datos y memoria por cliente',
    'Conexi\xF3n API con Meta Ads, Google Ads, TikTok Ads, Figma y CMS',
    'Gobernanza y supervisi\xF3n de entregables por el Director de Marketing IA',
    'Entregables ilimitados: copies, creatividades, informes y optimizaciones',
    'Soporte prioritario y onboarding asistido para tu equipo',
    'Garant\xEDa de respaldo t\xE9cnico avalado por Lanzadera',
  ]
  const guarantees = [
    {
      title: 'Sin Permanencia',
      desc: 'Flexibilidad total. Puedes pausar o cancelar tu suscripci\xF3n en cualquier momento sin penalizaciones.',
    },
    {
      title: 'Despliegue Inmediato',
      desc: 'Tu equipo de IA se integra y configura con tus gu\xEDas de marca en menos de 48 horas.',
    },
    {
      title: 'Privacidad Blindada',
      desc: 'Los datos, campa\xF1as y estrategias de tus clientes jam\xE1s se comparten ni entrenan modelos p\xFAblicos.',
    },
  ]
  return (
    <section
      id="precios"
      className="py-24 relative bg-[#012622] bg-tactical-dots border-t border-[#00FF9D]/15"
    >
      {/* Anchor for backward compatibility with #precios-roi */}
      <div id="precios-roi" className="absolute -top-10" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-[#05332E] border border-[#00FF9D]/30 text-xs font-mono text-[#00FF9D] uppercase tracking-wider mb-4">
            <DollarSign className="w-3.5 h-3.5" />
            Transparencia Radical & Cero Comisiones Ocultas
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight mb-4">
            Precios Claros para{' '}
            <span className="text-[#00FF9D]">Tu Agencia</span>
          </h2>
          <p className="text-base sm:text-lg text-[#CBD5E1]">
            Una tarifa plana diseñada para dar soporte completo a tus primeros
            10 clientes sin disparar tus costes fijos.
          </p>
        </div>

        {/* Pricing Card & Scope Details */}
        <div className="max-w-5xl mx-auto">
          <div className="rounded-3xl p-8 sm:p-12 bg-[#05332E] border-2 border-[#00FF9D] shadow-[0_0_50px_rgba(0,255,157,0.2)] relative overflow-hidden">
            {/* Top Recommended Tag */}
            <div className="absolute top-0 right-0 bg-[#00FF9D] text-[#012622] text-xs font-black uppercase tracking-wider px-5 py-1.5 rounded-bl-xl shadow-md flex items-center gap-1.5">
              <Sparkles className="w-3.5 h-3.5 fill-[#012622]" />
              Tarifa Plana Oficial
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
              {/* Left Column: Price and Core Offer */}
              <div className="lg:col-span-6 space-y-6">
                <div>
                  <span className="text-xs font-mono uppercase tracking-widest text-[#00FF9D] font-bold block mb-1">
                    Suscripción plana para tu agencia
                  </span>
                  <h3 className="text-3xl sm:text-4xl font-extrabold text-white">
                    Plan Agencia Escala
                  </h3>
                  <p className="text-sm text-[#CBD5E1] mt-2">
                    Todo tu departamento de marketing con 10 agentes de IA
                    operativos 24/7.
                  </p>
                </div>

                {/* Price display */}
                <div className="p-6 rounded-2xl bg-[#012622] border border-[#00FF9D]/30">
                  <div className="flex items-baseline gap-2">
                    <span className="text-5xl sm:text-6xl font-black text-white tracking-tight font-mono">
                      500 €
                    </span>
                    <span className="text-base text-[#CBD5E1] font-mono">
                      / mes
                    </span>
                  </div>

                  <div className="mt-3 pt-3 border-t border-[#0A3F39] flex flex-col gap-2">
                    <div className="inline-flex items-center gap-2 text-xs font-mono text-[#00FF9D] font-bold">
                      <Sparkles className="w-4 h-4 flex-shrink-0" />
                      <span>
                        Coste efectivo: &lt; 50 € / mes por cliente (menos de
                        1,70 €/día)
                      </span>
                    </div>
                    <div className="text-xs text-[#CBD5E1]">
                      <strong className="text-white">Incluye:</strong> Gestión y
                      cobertura completa para{' '}
                      <strong className="text-[#00FF9D]">
                        10 clientes activos
                      </strong>{' '}
                      sin coste adicional por agente o entregable.
                    </div>
                  </div>
                </div>

                {/* CTA Button */}
                <div>
                  <button
                    onClick={onSelectPlan}
                    className="w-full flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#00FF9D] hover:bg-[#00E676] text-[#012622] font-extrabold text-base transition-all duration-200 shadow-[0_0_25px_rgba(0,255,157,0.4)] hover:shadow-[0_0_35px_rgba(0,255,157,0.6)] cursor-pointer active:scale-[0.99]"
                  >
                    <span>Solicitar Despliegue en mi Agencia</span>
                    <ArrowRight className="w-5 h-5" />
                  </button>
                  <div className="mt-3 text-center text-xs font-mono text-[#CBD5E1]/70 flex items-center justify-center gap-2">
                    <ShieldCheck className="w-4 h-4 text-[#00FF9D]" />
                    <span>
                      Sin permanencia • Onboarding guiado en menos de 48 horas
                    </span>
                  </div>
                </div>
              </div>

              {/* Right Column: Included Features Checklist */}
              <div className="lg:col-span-6 bg-[#031E1B] p-6 sm:p-8 rounded-2xl border border-[#00FF9D]/20">
                <h4 className="text-sm font-mono uppercase tracking-wider text-white font-bold mb-4 flex items-center gap-2">
                  <Layers className="w-4 h-4 text-[#00FF9D]" />
                  Qué incluye la suscripción:
                </h4>

                <div className="space-y-3">
                  {includedFeatures.map((feat, i) => (
                    <div
                      key={i}
                      className="flex items-start gap-3 text-xs sm:text-sm text-[#CBD5E1]"
                    >
                      <div className="w-4 h-4 rounded-full bg-[#00FF9D]/20 text-[#00FF9D] flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="w-3 h-3 stroke-[3]" />
                      </div>
                      <span className="leading-snug">{feat}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-6 pt-5 border-t border-[#0A3F39] flex items-center justify-between text-xs font-mono text-[#00FF9D]">
                  <span className="flex items-center gap-1.5">
                    <span className="w-2 h-2 rounded-full bg-[#00FF9D] animate-pulse" />
                    Capacidad disponible
                  </span>
                  <span>10 / 10 Clientes</span>
                </div>
              </div>
            </div>

            {/* Bottom 3 Trust Pillars */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8 pt-8 border-t border-[#00FF9D]/20">
              {guarantees.map((g, idx) => (
                <div
                  key={idx}
                  className="p-4 rounded-xl bg-[#012622]/60 border border-white/5"
                >
                  <div className="flex items-center gap-2 text-white font-bold text-sm mb-1">
                    <CheckCircle2 className="w-4 h-4 text-[#00FF9D]" />
                    <span>{g.title}</span>
                  </div>
                  <p className="text-xs text-[#CBD5E1] leading-relaxed">
                    {g.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export { PricingAndRoi }
